module.exports = __webpack_public_path__ + "img/max-file-edit.c7ec032a.svg";